import { Button, Card, CardContent, Divider } from '@mui/material';
import Grid from 'components/core/Grid';
import { IS_DIRECT_VACATIONS } from 'config/envSetup';

import { ContactRow } from './ContactRow';

import { SetupItem } from 'components/styles';
import { SubHeader } from './SubHeader';
import { alluraDirectNorthAmericanPhoneNumber } from '@alluradirect/react';
import { brandInfo } from 'config/brand';

interface Props {
  isGuestApp: boolean;
  hasContactDialog?: boolean;
  openContactDialog: () => void;
}

export const HelperDrawerBody = ({ openContactDialog, hasContactDialog = true, isGuestApp }: Props) => {
  const { brandName, brandEmail } = brandInfo(IS_DIRECT_VACATIONS(), isGuestApp);

  return (
    <Grid item xs={12}>
      <Card>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <SubHeader title="Contact Details" />
                <ContactRow
                  contactType="text"
                  title="Phone Support"
                  contactDetail="Monday to Friday \n 8:00am to 4:00pm PST"
                />
                <ContactRow contactType="text" title="Email Support" contactDetail="24 / 7" />
              </Grid>
            </Grid>
            <Divider />
            <ContactRow title="Email Address" contactType="email" contactDetail={brandEmail} />
            <Divider />
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <SubHeader title="Toll-Free Numbers" />
                <ContactRow title="Local" contactType="telephone" contactDetail="604-707-6700" />
                <ContactRow
                  title="North America"
                  contactType="telephone"
                  contactDetail={alluraDirectNorthAmericanPhoneNumber}
                />
                <ContactRow title="United Kingdom" contactType="telephone" contactDetail="0800-028-9346" />
                <ContactRow title="Australia" contactType="telephone" contactDetail="1-800-358-152" />
                <ContactRow title="Hong Kong" contactType="telephone" contactDetail="800-903-329" />
              </Grid>
            </Grid>
            {hasContactDialog ? (
              <SetupItem item xs={12}>
                <Button fullWidth variant="contained" color="secondary" onClick={openContactDialog}>
                  Contact {brandName}
                </Button>
              </SetupItem>
            ) : null}
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};
